<template>
  <div class="relative locations">
    <div class="add-button c-float m-b-25">
      <div class="flex-center float-left">
        <Btn
          @click.native="routeIt"
          class="light bordered empty d-inline-block m-r-15 fix-40"
          :icon="{
            name: 'arrowLeftBig',
            size: '20',
          }" />
        <p class="user-name">{{ `${$t('invoice')} ${get_invoice.invoice_number}` }}</p>
      </div>
      <Dropdown
        v-if="getDropdownOptions.length"
        class="float-right drop-right"
        :buttonText="$t('Actions')"
        :dropdownOptions="getDropdownOptions"
        @optionSelected="optionSelected" />
      <a
        style="display: none"
        :download="`INVOICE_${$route.params.id}`"
        ref="downloadInvoicePDF"
        :href="invoicePdfPath" />
      <iframe
        style="display: none;"
        ref="printPDF"
        id="printPDF"
        name="printPDF"
        width="100%"
        :src="pdfFilePath"
        height="600px" />
    </div>
    <!-- HEADER -->
    <div class="row card info-wrap m-b-40" style="margin-left: 0; margin-right: 0" v-if="get_end_of_day !== null">
      <div class="col-xs-3">
        <div class="info-box c-float">
          <LogosSVG
            class="float-left m-r-15"
            :name="get_invoice.shipping_agent_name"
            size="40" />
          <div class="float-left">
            <p class="big-info-text">{{ get_invoice.shipping_agent_name }}</p>
            <p class="small-info-text">{{ get_invoice.date | dateTime }}</p>
          </div>
        </div>
      </div>
      <div class="col-xs-3">
        <div class="info-box c-float">
          <Icon
            :circle=true
            name="savedItems"
            size="20"
            class="float-left m-r-15" />
          <div class="float-left">
            <p class="big-info-text">{{ `${get_invoice.total_colli} ${$t('colli').toLowerCase()}` }}</p>
            <p class="small-info-text">{{ `${get_invoice.total_shipments} ${$t('shipments').toLowerCase()}` }}</p>
          </div>
        </div>
      </div>
      <div class="col-xs-3">
        <div class="info-box c-float">
          <Icon
            :circle=true
            name="pointer"
            size="20"
            class="float-left m-r-15" />
          <div class="float-left">
            <p class="big-info-text">{{ $t('booked_vs_invoiced') }}</p>
            <p class="small-info-text" :class="resolveClassByAmount(get_invoice.invoiced_difference)">{{ get_invoice.invoiced_difference | currency(null, get_invoice.currency) }}</p>
          </div>
        </div>
      </div>
      <div class="col-xs-3">
        <div class="info-box c-float">
          <Icon
            :circle=true
            name="document"
            size="20"
            class="float-left m-r-15" />
          <div class="float-left">
            <p class="big-info-text">{{ $t('invoiced_vs_price') }}</p>
            <p class="small-info-text" :class="resolveClassByAmount(get_invoice.agreement_control)">{{ get_invoice.agreement_control | currency(null, get_invoice.currency) }}</p>
          </div>
        </div>
      </div>
    </div>
    <!-- BODY -->
    <div class="row" style="margin-left: 0; margin-right: 0">
      <div class="c-float m-b-20">
      <h2 class="m-b-20 section-title float-left" v-if="get_end_of_day !== null">
        {{ $t('invoice_items') }}
      </h2>
        <div class="float-right">
          <div class="button outline m-r-10" :class="{disabled : tableDisplay !== 'inline'}" @click="tableDisplay = 'inline'">{{ $t('show_per_line') }}</div>
          <div class="button outline" :class="{disabled : tableDisplay !== 'detail'}" @click="tableDisplay = 'detail'">{{ $t('show_per_shipment') }}</div>
        </div>
      </div>
      <DataTable
        :dropdown=false
        :tableHeader=true
        :tableHead=true
        tableAPI="INVOICE_ITEMS"
        tableActions="INVOICE_ITEMS"
        :apiID="$route.params.id"
        :totalCount="50"
        :checkbox=false
        :type=false
        :single-line="singleLine"
        :field-formatter-configuration="fieldFormatConfig"
        :detail-view="detailViewComputed"
        :count="get_invoice_item_count"
        :list="invoiceItemDataComputed"
        :referenceData="referenceData"
        :filterOptions="filterOptions"
      />
    </div>
    <a
      style="display: none"
      :download="`invoice.csv`"
      ref="exportData"
      :href="exportDataPath" />
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from 'vuex';
import LogosSVG from "@/assets/images/logosSVG";
import DataTable from '@/components/table/index.vue';
import Btn from '@/components/elements/buttons';
import Dropdown from '@/components/global/dropdown';
import date from '@/mixins/date';
import invoiceDetailView from "@/components/table/finance/invoices/invoiceDetailView.vue";
import { DateTime } from 'luxon';
import localesByCurrency from '@/data/localesByCurrency';
import i18n from "@/i18n";

export default {
  name: 'invoice',
  components: {
    LogosSVG, DataTable, Btn, Dropdown,
  },
  mixins: [date],
  data() {
    return{
      get_end_of_day: {
        batch_agents_array: []
      },
      tableDisplay: 'detail',
      invoice: {},
      singleLine: false,
      invoiceItems: {},
      fieldFormatConfig: {
        waybill_number: [
          {
            type: 'event',
            options: {
              behavior: 'link',
              action: 'click',
              params: {
                'shipment_id' : 'shipment_id'
              },
              url: '/view-shipment/{shipment_id}'
            }
          }
        ],
        booked_price: [
          {
            type: 'currency',
            options: {
              currency_key: 'currency',
              conversion_key: 'currency_conversion'
            }
          },
        ],
        invoiced_price: [
          {
            type: 'currency',
            options: {
              currency_key: 'currency',
              conversion_key: 'currency_conversion'
            }
          },
        ],
        price_difference: [
          {
            type: 'currency',
            options: {
              currency_key: 'currency',
              conversion_key: 'currency_conversion'
            }
          },
          {
            type: 'css',
            options: {
              conditionalRule: 'zero_compare',
              conditions: {
                negative: 'text-warning',
                positive : 'text-error',
                equal: 'text-success'
              }
            }
          },
        ],
        agreement_control: [
          {
            type: 'currency',
            options: {
              currency_key: 'currency',
              conversion_key: 'currency_conversion'
            }
          },
          {
            type: 'css',
            options: {
              conditionalRule: 'zero_compare',
              conditions: {
                negative: 'text-warning',
                positive : 'text-error',
                equal: 'text-success'
              }
            }
          },
        ],
        date: [
          {
            type: 'dateTime',
            options: {
              format: this.defaultDateFormat(),
            }
          },
        ],
      },
      referenceDataInline: [
        {
          waybill_number: `${this.$t('waybill_number')}`,
        },
        {
          product_name: `${this.$t('description')}`,
        },
        {
          booked_price: `${this.$t('Booked')}`,
        },
        {
          invoiced_price: `${this.$t('invoiced_price')}`,
        },
        {
          price_difference: `${this.$t('price_diff')}`,
        },
        {
          agreement_control: `${this.$t('agreement_control')}`,
        }
      ],
      referenceDataDetail: [
        {
          waybill_number: `${this.$t('waybill_number')}`,
          shipment_subaccount_name: `${this.$t('account')}`,
        },
        {
          destinations: `${this.$t('destinations')}`,
          date: `${this.$t('date')}`,
        },
        {
          booked_price: `${this.$t('booked_price')}`,
          price_difference: `${this.$t('price_diff')}`,
        },
        {
          invoiced_price: `${this.$t('invoiced_price')}`,
          agreement_control: `${this.$t('agreement_control')}`,
        },
      ],
      detailView: {
        component: invoiceDetailView,
      },
      dropdownOptions: [],
      invoicePdfPath: '',
      downloadInvoicePDF: '',
      pdfFilePath: '',
      exportDataPath: '',
    };
  },
  computed: {
    ...mapGetters([
      'get_filters_menu',
      'get_active_filter',
      'get_invoice',
      'get_invoice_item_list',
      'get_invoice_item_count'
    ]),
    getDropdownOptions() {
      let dropdownOptions = [];
      if (this.get_invoice.invoice_pdf) {
        dropdownOptions.push({
          text: `${this.$t('Download invoice')}`,
          subText: `${this.$t('Download invoice pdf')}`,
          icon: 'cloudDownload',
        })
      }

      return dropdownOptions;
    },
    referenceData() {
      if (this.tableDisplay == 'inline') {
        this.singleLine = true;
        return this.referenceDataInline
      }
      this.singleLine = false;
      return this.referenceDataDetail
    },
    detailViewComputed() {
      if (this.tableDisplay == 'inline') {
        this.singleLine = true;
        return null
      }
      this.singleLine = false;
      return this.detailView
    },
    processedInvoiceItems() {
      const processed = [];
      this.get_invoice_item_list.forEach(item => {

        // Reference number
        const referenceNumber = [];
        if (item.pickup_reference) {
          referenceNumber.push(item.pickup_reference)
        }
        if (item.sender_reference) {
          referenceNumber.push(item.sender_reference)
        }
        if (item.receiver_reference) {
          referenceNumber.push(item.receiver_reference)
        }

        // Destination
        const destinations = [];
        if (item.pickup_country_code || item.pickup_post_code) {
          let destinationString = [];
          if (item.pickup_country_code) {
            destinationString.push(`${item.pickup_country_code}`)
          }
          if (item.pickup_post_code) {
            destinationString.push(item.pickup_post_code)
          }
          destinations.push(destinationString.join('-'))
        } else {
          let destinationString = [];
          if (item.country_from) {
            destinationString.push(item.country_from)
          }
          if (item.sender_post_code) {
            destinationString.push(item.sender_post_code)
          }
          destinations.push(destinationString.join('-'))

          destinationString = [];
          if (item.country_to) {
            destinationString.push(item.country_to)
          }
          if (item.receiver_post_code) {
            destinationString.push(item.receiver_post_code)
          }
          destinations.push(destinationString.join('-'))
        }

        const invoiceItem = {
          waybill_number: item.awb,
          shipment_subaccount_name: item.shipment_subaccount_name,
          reference_number: referenceNumber.join('-'),
          destinations: destinations.join('<span class="destination-char">></span>'),
          date: item.date,
       //   currency: 'DKK',
          currency_conversion: item.currency_conversion,
          type: item.type,
          shipment_id: item.system_shipment_id,
          product_name: item.purchased_item ? item.purchased_item : item.type == 9 ? i18n.t('fuel') : '',
          booked_price: item.booked_price,
          invoiced_price: item.data_price,
          price_difference: item.data_price - item.booked_price,
          agreement_control: item.data_price - item.sales_price,
          booked_weight: item.shipment_package_weight,
          booked_length: item.shipment_package_length,
          booked_width: item.shipment_package_width,
          booked_height: item.shipment_package_height,
          booked_dimensions: this.generateDimensionString(item.shipment_package_length, item.shipment_package_width, item.shipment_package_height),
          booked_ldm: item.shipment_package_load_meter,
          booked_volume: item.cubic_meter,
          invoiced_weight: item.data_weight,
          invoiced_length: item.data_length,
          invoiced_width: item.data_width,
          invoiced_height: item.data_height,
          invoiced_dimensions: this.generateDimensionString(item.data_length, item.data_width, item.data_height),
          invoiced_ldm: item.load_meter,
          invoiced_volume: item.cubic_meter,
          ldm_difference: item.load_meter - item.shipment_package_load_meter,
          volume_difference: item.cubic_meter - item.shipment_package_cubic_meter,
          dimension_difference: '',
          weight_difference: ''
        }
        processed.push(invoiceItem)
      })
      return processed;
    },
    invoiceItemDataComputed() {
      if (this.tableDisplay === 'inline') {
        return this.processedInvoiceItems
      }

      const groupedShipments = [];

      this.processedInvoiceItems.forEach(item => {
        if (!groupedShipments[item.waybill_number]) {
          groupedShipments[item.waybill_number] = {};
          groupedShipments[item.waybill_number].waybill_number = item.waybill_number;
          groupedShipments[item.waybill_number].shipment_subaccount_name = item.shipment_subaccount_name;
          groupedShipments[item.waybill_number].shipment_id = item.shipment_id;
          groupedShipments[item.waybill_number].reference_number = item.reference_number;
          groupedShipments[item.waybill_number].product_name = item.product_name;
          groupedShipments[item.waybill_number].destinations = item.destinations;
          groupedShipments[item.waybill_number].currency_conversion = item.currency_conversion;
          groupedShipments[item.waybill_number].date = item.date;
          groupedShipments[item.waybill_number].booked_price = '-';
          groupedShipments[item.waybill_number].price_difference = '-';
          groupedShipments[item.waybill_number].invoiced_price = '-';
          groupedShipments[item.waybill_number].agreement_control = '-';
          groupedShipments[item.waybill_number].booked_weight = '-';
          groupedShipments[item.waybill_number].booked_length = '-';
          groupedShipments[item.waybill_number].booked_width = '-';
          groupedShipments[item.waybill_number].booked_height = '-';
          groupedShipments[item.waybill_number].booked_dimensions = '-';
          groupedShipments[item.waybill_number].booked_ldm = '-';
          groupedShipments[item.waybill_number].booked_volume = '-';
          groupedShipments[item.waybill_number].invoiced_weight = '-';
          groupedShipments[item.waybill_number].invoiced_length = '-';
          groupedShipments[item.waybill_number].invoiced_width = '-';
          groupedShipments[item.waybill_number].invoiced_height = '-';
          groupedShipments[item.waybill_number].invoiced_dimensions = '-';
          groupedShipments[item.waybill_number].invoiced_ldm = '-';
          groupedShipments[item.waybill_number].invoiced_volume = '-';
          groupedShipments[item.waybill_number].ldm_difference = '-';
          groupedShipments[item.waybill_number].volume_difference = '-';
          groupedShipments[item.waybill_number].weight_difference = '-';
          groupedShipments[item.waybill_number].length_difference = null;
          groupedShipments[item.waybill_number].width_difference = null;
          groupedShipments[item.waybill_number].height_difference = null;
          groupedShipments[item.waybill_number].ldm_css_class = '';
          groupedShipments[item.waybill_number].volume_css_class = '';
          groupedShipments[item.waybill_number].length_css_class = '';
          groupedShipments[item.waybill_number].width_css_class = '';
          groupedShipments[item.waybill_number].height_css_class = '';
          groupedShipments[item.waybill_number].weight_css_class = '';

          groupedShipments[item.waybill_number].products = [];

        }

        /**
         *  Pricing
         */
        if (item.booked_price) {
          if (item.booked_price !== '-') {
            if (groupedShipments[item.waybill_number].booked_price === '-') {
              groupedShipments[item.waybill_number].booked_price = 0;
            }
            groupedShipments[item.waybill_number].booked_price += this.toFixedNumber(item.booked_price, 2);
          }
        }
        if (item.price_difference !== '-') {
          if (groupedShipments[item.waybill_number].price_difference === '-') {
            groupedShipments[item.waybill_number].price_difference = 0;
          }
          groupedShipments[item.waybill_number].price_difference += this.toFixedNumber(item.price_difference, 2);
        }
        if (item.invoiced_price !== '-') {
          if (groupedShipments[item.waybill_number].invoiced_price === '-') {
            groupedShipments[item.waybill_number].invoiced_price = 0;
          }
          groupedShipments[item.waybill_number].invoiced_price += this.toFixedNumber(item.invoiced_price, 2);
        }
        if (item.agreement_control !== '-') {
          if (groupedShipments[item.waybill_number].agreement_control === '-') {
            groupedShipments[item.waybill_number].agreement_control = 0;
          }
          groupedShipments[item.waybill_number].agreement_control += this.toFixedNumber(item.agreement_control, 2);
        }

        /**
         *  Package dimensions
         */
        if (item.booked_weight) {
          groupedShipments[item.waybill_number].booked_weight = item.booked_weight;
          if (item.invoiced_weight) {
            groupedShipments[item.waybill_number].weight_difference = item.invoiced_weight - groupedShipments[item.waybill_number].booked_weight;
            groupedShipments[item.waybill_number].weight_css_class = this.resolveClassByAmount(groupedShipments[item.waybill_number].weight_difference);
          }
        }

        if (item.invoiced_weight) {
          groupedShipments[item.waybill_number].invoiced_weight = item.invoiced_weight;
        }

        if (item.booked_ldm) {
          groupedShipments[item.waybill_number].booked_ldm = item.booked_ldm;
          if (item.invoiced_ldm) {
            groupedShipments[item.waybill_number].ldm_difference = item.invoiced_ldm - groupedShipments[item.waybill_number].booked_ldm;
            groupedShipments[item.waybill_number].ldm_css_class = this.resolveClassByAmount(groupedShipments[item.waybill_number].ldm_difference);
          }
        }

        if (item.invoiced_ldm) {
          groupedShipments[item.waybill_number].invoiced_ldm = item.invoiced_ldm;
        }

        if (item.booked_volume) {
          groupedShipments[item.waybill_number].booked_volume = item.booked_volume;
          if (item.invoiced_volume) {
            groupedShipments[item.waybill_number].volume_difference = item.invoiced_volume - groupedShipments[item.waybill_number].booked_volume;
            groupedShipments[item.waybill_number].volume_css_class = this.resolveClassByAmount(groupedShipments[item.waybill_number].volume_difference);
          }
        }

        if (item.invoiced_volume) {
          groupedShipments[item.waybill_number].invoiced_volume = item.invoiced_volume;
        }

        if (item.booked_length) {
          groupedShipments[item.waybill_number].booked_length = item.booked_length;
          if (item.invoiced_length) {
            groupedShipments[item.waybill_number].length_difference = item.invoiced_length - item.booked_length ;
            groupedShipments[item.waybill_number].length_css_class = this.resolveClassByAmount(groupedShipments[item.waybill_number].length_difference);
          }
        }

        if (item.invoiced_length) {
          groupedShipments[item.waybill_number].invoiced_length = item.invoiced_length;
        }

        if (item.booked_width) {
          groupedShipments[item.waybill_number].booked_width = item.booked_width;
          if (item.invoiced_width) {
            groupedShipments[item.waybill_number].width_difference = item.invoiced_width - item.booked_width;
            groupedShipments[item.waybill_number].width_css_class = this.resolveClassByAmount(groupedShipments[item.waybill_number].width_difference);
          }
        }

        if (item.invoiced_width) {
          groupedShipments[item.waybill_number].invoiced_width = item.invoiced_width;
        }

        if (item.booked_height) {
          groupedShipments[item.waybill_number].booked_height = item.booked_height;
          if (item.booked_height) {
            groupedShipments[item.waybill_number].height_difference = item.invoiced_height - item.booked_height;
            groupedShipments[item.waybill_number].height_css_class = this.resolveClassByAmount(groupedShipments[item.waybill_number].height_difference);
          }
        }

        if (item.booked_length && item.booked_width && item.booked_height) {
          groupedShipments[item.waybill_number].booked_dimensions = this.generateDimensionString(item.booked_length, item.booked_width, item.booked_height);
        }

        if (item.invoiced_length && item.invoiced_width && item.invoiced_height) {
          groupedShipments[item.waybill_number].invoiced_dimensions = this.generateDimensionString(item.invoiced_length, item.invoiced_width, item.invoiced_height);
        }

        groupedShipments[item.waybill_number].products.push(item);
      })

      return Object.values(groupedShipments)
    },

    filterOptions() {
      return {
        filtersMenu: this.get_filters_menu,
        activeFilter: this.get_active_filter,
        tableName: 'invoices',
        tableApi: 'admin-vendor-invoice/get-vendor-invoice-items/' + this.$route.params.id,
        filterFields: {
          booked_on_platform: {
            label: `${this.$t('booked_on_platform')}`,
            type: 'select',
            value: {
              value: '',
              additional: '',
            },
            options: [
              {text: `${this.$t('yes')}`, value: '1'},
              {text: `${this.$t('no')}`, value: '0'},
            ],
          },
          invoiced_differences: {
            label: this.$t('show_only_invoiced_differences'),
            type: 'financeTypes',
            value: {
              value: [],
              additional: '',
            },
          },
          agreement_differences: {
            label: this.$t('show_only_agreement_differences'),
            type: 'financeTypes',
            value: {
              value: [],
              additional: '',
            },
          },
          reference: {
            label: `${this.$t('Reference')}`,
            type: 'input',
            value: {
              value: '',
              additional: '',
            },
          },
          date: {
            label: this.$t('date'),
            type: 'date',
            value: {
              value: null,
              additional: '',
            },
          },
          sender_postcode: {
            label: `${this.$t('sender_post_code')}`,
            type: 'input',
            value: {
              value: '',
              additional: '',
            },
          },
          sender_country: {
            label: `${this.$t('sender_country_id')}`,
            type: 'country',
            value: {
              value: [],
              additional: '',
            },
          },
          receiver_postcode: {
            label: `${this.$t('receiver_post_code')}`,
            type: 'input',
            value: {
              value: '',
              additional: '',
            },
          },
          receiver_country: {
            label: `${this.$t('receiver_country_id')}`,
            type: 'country',
            value: {
              value: [],
              additional: '',
            },
          },
        },
        actionsOptions: [],
      }
    },
  },
  created() {
    this.$store.dispatch('GET_INVOICE', this.$route.params.id);
  },
  methods: {
    toFixedNumber(num, digits, base) {
      const pow = Math.pow(base ?? 10, digits);
      return Math.round(num * pow) / pow;
    },
    generateDimensionString(length, width, height) {
      if (!height || !length || !width) {
        return '-';
      }

      const dimensionString = [];
      dimensionString.push(length)
      dimensionString.push(width)
      dimensionString.push(height)

      return dimensionString.join(' x ')
    },
    resolveClassByAmount(amount) {
      if (amount < 0) {
        return 'text-warning';
      }
      if (amount > 0) {
        return 'text-error';
      }
      if (amount === 0) {
        return 'text-success';
      }
    },
    optionSelected(opt) {
      if(opt === 'dropOption1') {
        this.downloadPDF();
      }
    },
    routeIt() {
      this.$router.go(-1);
    },
    downloadPDF() {
      this.$store.dispatch('DOWNLOAD_VENDOR_INVOICE', this.get_invoice.id).then((res) => {
        this.$nextTick(() => {
          let file = window.URL.createObjectURL(res);
          this.$refs.downloadInvoicePDF.href = file;
          this.invoicePdfPath = file;
          this.$refs.downloadInvoicePDF.click();
        })
      })
    },
  },
  destroyed() {
    this.$store.dispatch('CLEAR_INVOICE');
  },
}
</script>
<style>
.destination-char {
  padding: 0 5px;
  color: #979EA3;
}
</style>
